export default {
  "Nameplate": "_Nameplate_1jnsm_1",
  "Card": "_Card_1jnsm_7",
  "MatchCard": "_MatchCard_1jnsm_21",
  "OptinCard": "_OptinCard_1jnsm_25",
  "CardSubject": "_CardSubject_1jnsm_29"
};import "ni:sha-256;Y7Bh2qV_zXVE5QsBG-X-xH-ZQxZKSLgSEfDvZZufhPI";